import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f71142d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
    key: 0,
    class: "selected"
};
const _hoisted_3 = { class: "menu" };
const _hoisted_4 = { class: "display" };
const _hoisted_5 = ["href"];
const _hoisted_6 = { class: "menu" };
const _hoisted_7 = { class: "display" };
const _hoisted_8 = ["href"];
const _hoisted_9 = { class: "menu" };
const _hoisted_10 = { class: "display" };
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useMessage } from '@/const/messages';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        current: null
    },
    emits: ["click"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const store = useStore();
        const onClick = (value) => emits('click', value);
        const { STAKING_MENU, format } = useMessage();
        const menus = [
            {
                icon: 'home',
                tab: 'dashboard',
                display: STAKING_MENU.DASHBOARD,
            },
            {
                icon: 'add_circle',
                tab: 'staking',
                display: STAKING_MENU.STAKING,
            },
            {
                icon: 'cancel',
                tab: 'cancel',
                display: STAKING_MENU.CANCEL,
            },
            {
                icon: 'history',
                tab: 'history',
                display: STAKING_MENU.HISTORY,
            },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("nav", null, [
                _createElementVNode("ul", {
                    class: _normalizeClass({ 'fixed-menu': _unref(store).state.isSmartPhone })
                }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menus, (menu) => {
                        return _createElementVNode("li", {
                            key: menu.tab,
                            onClick: ($event) => (onClick(menu.tab)),
                            class: _normalizeClass({ selectli: props.current === menu.tab })
                        }, [
                            (!_unref(store).state.isSmartPhone && props.current === menu.tab)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(MaterialIcon, {
                                    name: menu.icon,
                                    class: "icon"
                                }, null, 8, ["name"]),
                                _createElementVNode("b", _hoisted_4, _toDisplayString(_unref(format)(menu.display)), 1)
                            ])
                        ], 10, _hoisted_1);
                    }), 64)),
                    _createElementVNode("li", null, [
                        _createElementVNode("a", {
                            href: _unref(format)(_unref(STAKING_MENU).TERMS_OF_USE_LINK),
                            target: "_blank",
                            class: "term-link"
                        }, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(MaterialIcon, {
                                    name: "picture_as_pdf",
                                    class: "icon"
                                }),
                                _createElementVNode("b", _hoisted_7, _toDisplayString(_unref(format)(_unref(STAKING_MENU).TERMS_OF_USE)), 1)
                            ])
                        ], 8, _hoisted_5)
                    ]),
                    _createElementVNode("li", null, [
                        _createElementVNode("a", {
                            href: _unref(format)(_unref(STAKING_MENU).ANNOUNCEMENT_LINK),
                            target: "_blank",
                            class: "term-link"
                        }, [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(MaterialIcon, {
                                    name: "picture_as_pdf",
                                    class: "icon"
                                }),
                                _createElementVNode("b", _hoisted_10, _toDisplayString(_unref(format)(_unref(STAKING_MENU).ANNOUNCEMENT)), 1)
                            ])
                        ], 8, _hoisted_8)
                    ])
                ], 2)
            ]));
        };
    }
});
